import React, { useState } from "react";
import {
  Modal,
  Input,
  List,
  Button,
  notification,
} from "antd";

import upperCaseSentences from "helpers/upperCaseSentences";
import useCreate from "hooks/useCreate";
import { useCustomComments } from "context/providers/custom_comments";
import ModalDelete from "components/ModalDelete";
import { api, handleErrors } from "helpers/api";

const ManageModal = ({ handleClose }) => {
  const { data, refetch } = useCustomComments();

  const [content, setContent] = useState("");
  const [id_deleting, setIdDeleting] = useState(null);

  const { is_saving, create } = useCreate({
    path: "/custom_comments",
    onSuccess: refetch,
  });

  const handleOk = async () => {
    try {
      await create({
        content,
      });
      setContent("");
    } catch (error) {
      console.log(error);
    }
  };

  const handleDelete = async (id) => {
    try {
      setIdDeleting(id);
      await api.delete(`/custom_comments/${id}`);
      refetch();
    } catch (error) {
      notification.error({
        message: handleErrors(
          error,
          "Wystąpił błąd podczas usuwania"
        ),
      });
    } finally {
      setIdDeleting(null);
    }
  };

  return (
    <Modal
      maskClosable={false}
      width={700}
      title="Zarządzaj stałymi komentarzami"
      open={true}
      cancelText="Zamknij"
      onOk={(e) => {
        e.stopPropagation();
        handleClose();
      }}
      onCancel={(e) => {
        e.stopPropagation();
        handleClose();
      }}
      cancelButtonProps={{ style: { display: "none" } }}
      okText="Zamknij"
    >
      <Input.TextArea
        style={{ marginBottom: 20 }}
        value={content}
        onChange={({ target: { value } }) =>
          setContent(upperCaseSentences(value))
        }
        rows={7}
        maxLength={400}
        showCount={true}
      />
      <Button
        type="primary"
        htmlType="submit"
        onClick={handleOk}
        disabled={!content || is_saving}
        loading={is_saving}
      >
        Dodaj
      </Button>
      <List
        style={{
          marginTop: 24,
          maxHeight: 300,
          overflowY: "scroll",
        }}
        size="small"
        bordered
        dataSource={data}
        renderItem={({ id, content }) => (
          <List.Item
            key={id}
            actions={[
              <ModalDelete
                only_icon
                loading={id_deleting === id}
                text={<strong>{content}</strong>}
                handleDelete={() => handleDelete(id)}
              />,
            ]}
          >
            {content}
          </List.Item>
        )}
      />
    </Modal>
  );
};

export default ManageModal;
